import React, { useState } from 'react';

import { useAccessGuard } from 'src/components/auth';
import { OptionsMenuItem, ReusableMenu } from 'src/components/index';
import { Apollo } from 'src/gql/generated';
import type { ReactSetStateAction } from 'src/types/general';

interface RolesMenuProps {
  setRenameDialogOpen: ReactSetStateAction<boolean>;
}

export function RolesOptionsMenu({ setRenameDialogOpen }: RolesMenuProps): JSX.Element | null {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const handleOpen = useAccessGuard({
    callback: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) =>
      setAnchorEl(event.currentTarget),
    minRole: Apollo.OrgRole.Admin,
  });
  const handleRename = useAccessGuard({
    callback: () => {
      setRenameDialogOpen(true);
      closeHandler();
    },
    minRole: Apollo.OrgRole.Admin,
  });

  function closeHandler(): void {
    setAnchorEl(null);
  }

  return (
    <ReusableMenu anchorEl={anchorEl} handleClose={closeHandler} handleOpen={handleOpen}>
      <OptionsMenuItem clickHandler={handleRename} text="Rename" />
    </ReusableMenu>
  );
}
